var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloneBidIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 666.7 666.7",
    style: {
      enableBackground: "new 0 0 666.7 666.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#4A94FF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "rect1770",
    className: "st0",
    d: "M433.3,200c-18.4,0-33.3,14.9-33.3,33.3v133.3c0,19-14.3,33.3-33.3,33.3H233.3 c-18.4,0-33.3,14.9-33.3,33.3v133.3c0,54.8,45.2,100,100,100h266.7c54.8,0,100-45.2,100-100V300c0-54.8-45.2-100-100-100H433.3z  M466.7,266.7h100c19,0,33.3,14.3,33.3,33.3v266.7c0,19-14.3,33.3-33.3,33.3H300c-19,0-33.3-14.3-33.3-33.3v-100h100 c54.8,0,100-45.2,100-100V266.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect1768",
    className: "st1",
    d: "M99.9,0C45.1,0,0,45.1,0,99.9v266.7c0,54.8,45.1,99.9,99.9,99.9h266.7 c54.8,0,99.9-45.1,99.9-99.9V99.9c0-54.8-45.1-99.9-99.9-99.9H99.9z M99.9,66.7h266.7c19,0,33.5,14.2,33.5,33.2v266.7 c0,19-14.4,33.5-33.5,33.5H99.9c-19,0-33.2-14.4-33.2-33.5V99.9C66.7,80.9,80.9,66.7,99.9,66.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloneBidIcon);
export default __webpack_public_path__ + "static/media/clone_bid_icon.0d32916e75ae7c0b4c2e46402208f339.svg";
export { ForwardRef as ReactComponent };